export class TrackingOutputModuleName{
    public static OPEN_TRACKING_MODULE = 'OPEN_TRACKING_MODULE';
}